import { useStore } from 'effector-react/ssr';

import { CommonData } from '@domains/common-data';
import { GlobalData } from '@domains/global-data';

import { rootDomain } from '@stores/root';

import { defaultSeoState } from '@utils/seo';

// --- Types ---

export type GlobalDataState = GlobalData;

// --- Constants ---

const globalDataInitialState: GlobalDataState = {
    pageKind: 'server',
    user: null,
    commonData: {
        user: null,
        settings: {
            cookie_banner_text: '',
            yandex_metrika_counter_id: null,
            yandex_smart_captcha_key: '',
            user_profile_block: {
                title: null,
                description: null,
            },
            seo: {
                title: null,
                description: null,
                site_name: null,
                image: null,
                not_found_page: defaultSeoState,
                checkout: defaultSeoState,
                checkout_successful: defaultSeoState,
            },
            footer_block: {
                text: null,
            },
            telegram_block: {
                title: null,
                description: null,
                button_text: null,
                button_url: null,
            },
            checkout_block: {
                order_delivery_max_days: 0,
                checkout_min_total_price_info_description: null,
                order_min_total_price_for_delivery: 0 as FeipApi.Kopecks,
                pickup_point: {
                    id: 0,
                    address: {
                        latitude: null,
                        longitude: null,
                        text: null,
                    },
                    working_hours: null,
                    working_start_time: null,
                    working_end_time: null,
                    until_close_time: null,
                },
            },
            other_city: {
                id: 0,
                delivery_info_block: {
                    title: null,
                    description: null,
                    delivery_starts_at_seconds_since_midnight: 0,
                    delivery_ends_at_seconds_since_midnight: 0,
                },
            },
            topline_text: null,
            survey_form_url: null,
            show_survey_banner: false,
        },
        menu: {
            header: [],
            footer: [],
        },
        contacts: {
            header: {
                phone: null,
            },
            support: {
                phone: null,
            },
            footer: {
                phones: [],
            },
        },
        cities: [],
    },
    categoriesList: {
        items: [],
    },
};

// --- Domain ---

const globalDataDomain = rootDomain.createDomain();

// --- Events ---

export const setGlobalData = globalDataDomain.createEvent<GlobalDataState>();

// --- Stores ---

export const $globalData = globalDataDomain
    .createStore<GlobalDataState>(globalDataInitialState, { name: 'global-data' })
    .on(setGlobalData, (state, value) => value);

export const $commonData = $globalData.map<CommonData>((data) => data.commonData);

// --- Hooks ---

export const useGlobalData = (): GlobalDataState => useStore($globalData);
export const useCommonData = (): CommonData => useStore($commonData);
